module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage addrule_edit"
  }, [(_vm.params.meassage) ? _c('div', {
    staticClass: "failMessage"
  }, [_vm._v("\n            退回原因：" + _vm._s(_vm.params.meassage) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "show-message": true,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属栏目",
      "prop": "columnId"
    }
  }, [_c('el-cascader', {
    ref: "cascaderColumn",
    attrs: {
      "size": "medium",
      "options": _vm.columnTree,
      "show-all-levels": true,
      "props": {
        value: 'id',
        label: 'name',
        children: 'dtos',
        checkStrictly: true
      },
      "value": _vm.ids,
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入标题"
    },
    model: {
      value: (_vm.params.title),
      callback: function($$v) {
        _vm.$set(_vm.params, "title", $$v)
      },
      expression: "params.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "缩略图"
    }
  }, [_c('imgs-upload', {
    attrs: {
      "tips": "（推荐尺寸780*440）",
      "limit": "1"
    },
    on: {
      "change": _vm.fileChange
    },
    model: {
      value: (_vm.params.thumbnail),
      callback: function($$v) {
        _vm.$set(_vm.params, "thumbnail", $$v)
      },
      expression: "params.thumbnail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "摘要",
      "prop": "summary"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "750px"
    },
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.params.summary),
      callback: function($$v) {
        _vm.$set(_vm.params, "summary", $$v)
      },
      expression: "params.summary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "suosContent",
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('text-editor', {
    ref: "textEditor",
    staticStyle: {
      "width": "750px"
    },
    model: {
      value: (_vm.params.content),
      callback: function($$v) {
        _vm.$set(_vm.params, "content", $$v)
      },
      expression: "params.content"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-7ac17a12"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/cms/article/article_publish/add/src/Subpage1.vue
// module id = 1530
// module chunks = 1